const initailState = {
  documentData: [],
  loadings: false,
  downloadFileLoading: false,
  uploadLoading: false,
  viewDocumentLoading: false,
  viewDocument: null,
  fileType: null,
};

export function allDocumentsReducer(state = initailState, { type, payload,fileType }) {
  switch (type) {
    case "GET_ALL_DOCUMENT":
      return { ...state, documentData: payload, loadings: false };
    case "SHOW_DOCUMENT_LOADING":
      return { ...state, loadings: true };
    case "SHOW_DOCUMENT_LOADDED":
      return { ...state, loadings: false };
    case "DOCUMENT_UPLOAD":
      return { ...state };
    case "DOWNLOAD_FILE_SUCCESS":
      return { ...state, downloadFileLoading: false };
    case "DOWNLOADING_FILE":
      return { ...state, downloadFileLoading: true };
    case "FAILED_DOWNLOAD_FILE":
      return { ...state, downloadFileLoading: false };
    case "UPLOAD_DOCUMENT_LOADING":
      return { ...state, uploadLoading: true };
    case "UPLOAD_DOCUMENT_SUCCESS": 
      return { ...state, uploadLoading: false };
    case "UPLOAD_DOCUMENT_FAILED":
      return { ...state, uploadLoading: false };
      case "VIEW_DOCUMENT_LOADING":
        return { ...state, viewDocumentLoading: true };
      case "VIEW_DOCUMENT_SUCCESS":
        return { ...state, viewDocumentLoading: false, viewDocument: payload, fileType: fileType };
      case "VIEW_DOCUMENT_FAILED":
        return { ...state, viewDocumentLoading: false };

    default:
      return state;
  }
}
